import { render, staticRenderFns } from "./CreateCostPricesAdditionalFee.vue?vue&type=template&id=71387732"
import script from "./CreateCostPricesAdditionalFee.vue?vue&type=script&lang=js"
export * from "./CreateCostPricesAdditionalFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports